var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgInfoSign = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 59,
  height: 59,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 29.5,
  cy: 29.5,
  r: 29.5,
  fill: "#FF7A00"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "m27.82 18.284-.005.01-10.995 21.5a1 1 0 0 0 .89 1.456H41.29a1 1 0 0 0 .89-1.455l-10.995-21.5-.005-.011-.158-.31-.63-1.233a1 1 0 0 0-1.782 0l-.63 1.233-.159.31Zm5.241-2.909L44.85 38.43c1.361 2.661-.572 5.82-3.561 5.82H17.71c-2.99 0-4.922-3.159-3.561-5.82l11.788-23.054c1.486-2.905 5.638-2.905 7.123 0ZM28 25.5a1.5 1.5 0 1 1 3 0v7a1.5 1.5 0 0 1-3 0v-7ZM29.5 36a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z",
  fill: "#fff"
})));
export { SvgInfoSign as ReactComponent };
export default __webpack_public_path__ + "7228bf33bf321bd31bd0ae6c802f842b.svg";